import { useNavigate } from 'react-router-dom';
import s from './styles';

function SecondaryMenu({ items = [] }) {
  const navigate = useNavigate();

  return (
    <div>
      {items.map((item, i) => (
        <s.ItemWrapper
          key={i}
          onClick={() => navigate(item.path)}
          last={i === items.length - 1}
        >
          {item.name}
        </s.ItemWrapper>
      ))}
    </div>
  );
}

export default SecondaryMenu;
